import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ProductService } from 'src/app/core/api/product/product.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { UserService } from 'src/app/core/api/user/user.service';
import { Fields } from 'src/app/utils/fields';

@Component({
  selector: 'app-family-list',
  templateUrl: './family-list.component.html',
  styleUrls: ['./family-list.component.scss'],
})
/**
 * Family List Component
 */
export class FamilyListComponent implements OnInit {
  labels = {
    familyName: 'family-list.family-name',
    productsCount: 'family-list.product-count',
    activeVip: 'family-list.activeVip',
    actions: 'family-list.actions',
    error: 'unexpected-error',
  };
  familyItems: any[] = [];

  vipConfigSeriesMap: any = {};

  loading = false;

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    private productService: ProductService,
    private readonly userService: UserService,
    private snackBarService: SnackBarService
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.getFamily();
  }

  /**
   * Method to get all family from de system
   */
  getFamily(): void {
    this.loading = true;
    this.productService.getAllDetailedFamilyProduct().subscribe({
      next: (family) => {
        this.familyItems = family;
      },
      error: () => {
        this.loading = false;
        this.snackBarService.error(this.labels.error);
      },
      complete: () => {
        this.loadVipSeriesConfig();
      },
    });
  }

  /**
   * Loads the Vip configuration for each series from back-end (User Management Service)
   */
  loadVipSeriesConfig(): void {
    this.loading = true;

    this.userService.getVipConfigSeries().subscribe((vipConfigSeries) => {
      for (const config of vipConfigSeries) {
        const familyPk = config[Fields.FAMILY_PRIMARY_KEY];
        this.vipConfigSeriesMap[familyPk] = config;
      }
      this.loading = false;
    });
  }

  /**
   * Refresh all the family list
   */
  refresh(): void {
    this.getFamily();
  }
}
